"use client"
import { createSvgIcon, useTheme } from "@mui/material"
import { get } from "lodash"
import type { IconProps } from "../types"

const File = createSvgIcon(
  <path d="M8.5 17.5H15.5V16.5H8.5V17.5ZM8.5 13.5H15.5V12.5H8.5V13.5ZM5 21V3H14.5L19 7.5V21H5ZM14 8V4H6V20H18V8H14Z" />,
  "File",
)

const FileIcon = (props: IconProps) => {
  const { fill, sx, ...rest } = props
  const theme = useTheme()
  const _fill = (fill && get(theme.palette, fill)) || theme.palette.text.primary
  return <File sx={{ fill: _fill, ...sx }} {...rest} />
}

export default FileIcon
